import { Stage } from './configurations';

export const SERVICE_ENDPOINTS = {
  [Stage.DEV]: 'https://service.beta.contentflywheel.marketing.aws.a2z.org.cn',
  [Stage.BETA]: 'https://service.beta.contentflywheel.marketing.aws.a2z.org.cn',
  [Stage.GAMMA]: 'https://service.gamma.contentflywheel.marketing.aws.a2z.org.cn',
  [Stage.PROD]: 'https://service.prod.contentflywheel.marketing.aws.a2z.org.cn',
};

export const CONNECTION_MANAGEMENT_ENDPOINTS = {
  global: {
    [Stage.DEV]: 'https://t8vb7h9mc8.execute-api.us-east-1.amazonaws.com/prod',
    [Stage.BETA]: 'https://t8vb7h9mc8.execute-api.us-east-1.amazonaws.com/prod',
    [Stage.GAMMA]: 'https://t8vb7h9mc8.execute-api.us-east-1.amazonaws.com/prod',
    [Stage.PROD]: 'https://t8vb7h9mc8.execute-api.us-east-1.amazonaws.com/prod',
  },
  china: {
    [Stage.DEV]: 'https://df5mb8sp36.execute-api.cn-northwest-1.amazonaws.com.cn/prod',
    [Stage.BETA]: 'https://df5mb8sp36.execute-api.cn-northwest-1.amazonaws.com.cn/prod',
    [Stage.GAMMA]: 'https://df5mb8sp36.execute-api.cn-northwest-1.amazonaws.com.cn/prod',
    [Stage.PROD]: 'https://df5mb8sp36.execute-api.cn-northwest-1.amazonaws.com.cn/prod',
  },
};

export const WEBSITE_ENDPOINTS = {
  [Stage.DEV]: 'http://localhost:3000',
  [Stage.BETA]: 'https://portal.beta.contentflywheel.marketing.aws.a2z.org.cn',
  [Stage.GAMMA]: 'https://portal.gamma.contentflywheel.marketing.aws.a2z.org.cn',
  [Stage.PROD]: 'https://portal.prod.contentflywheel.marketing.aws.a2z.org.cn',
};

// Allowed origins for iframe embedding
export const ALLOWED_IFRAME_ORIGINS = {
  [Stage.DEV]: ['*'],
  [Stage.BETA]: ['*'], // [WEBSITE_ENDPOINTS[Stage.BETA], https://dev.brainforce.dci.aws.a2z.org.cn:3000', 'https://beta.brainforce.dci.aws.a2z.org.cn'],
  [Stage.GAMMA]: [WEBSITE_ENDPOINTS[Stage.GAMMA], 'https://gamma.brainforce.dci.aws.a2z.org.cn'],
  [Stage.PROD]: [WEBSITE_ENDPOINTS[Stage.PROD], 'https://brainforce.dci.aws.a2z.org.cn', 'https://prod.brainforce.dci.aws.a2z.org.cn'],
};
